import {
  getCommentsForDispute,
  getDataForDispute,
  getHireJobs,
  getFeaturedListings,
  getBoostedPosts,
  getTableInfo,
  updateDonationAmount,
  getPaymentIntegrities,
  getUnresolvedPayments,
  addAdminLogging,
  getPaginateItems,
  simpleSearch as simpleSearchApi,
  getNotes,
  getHistory,
  getAdminLogging
} from "@/api";
import { formatDates, getHeaders } from "@/helpers";

export default {
  async getHireJobs(state, payload) {
    let hireJobs = await getHireJobs();
    state.commit("modify", { property: "hirejobs", value: hireJobs });
    return hireJobs;
  },

  async getFeaturedListings(state, payload) {
    const featuredListings = await getFeaturedListings();
    return featuredListings;
  },

  async getBoostedPosts(state, payload) {
    const boostedPosts = await getBoostedPosts();
    return boostedPosts;
  },

  async getNotes(state, payload) {
    const notes = await getNotes();
    return notes;
  },

  async getHistory(state, payload) {
    const history = await getHistory();
    return history;
  },

  async getActivityLog(state, payload) {
    const activityLog = await getAdminLogging();
    return activityLog;
  },

  async getData(state, payload) {
    try {
      console.log(`getData: Fetching data for ${payload.tablename}`);
      const response = (await getTableInfo(payload.tablename)) as any;
      console.log(`getData: Received response for ${payload.tablename}:`, {
        isArray: Array.isArray(response),
        length: Array.isArray(response) ? response.length : "N/A",
        firstItem:
          Array.isArray(response) && response.length > 0 ? response[0] : null
      });

      // Ensure response is an array
      if (!Array.isArray(response)) {
        console.error(
          `getData: Response for ${payload.tablename} is not an array:`,
          response
        );
        state.commit("modifyMultiple", [
          {
            property: "tableHeaders",
            value: []
          },
          {
            property: "tableContent",
            value: []
          }
        ]);
        return;
      }

      const headers = response.length ? getHeaders(response) : [];
      const content = response.length ? formatDates(response) : [];

      console.log(`getData: Setting data for ${payload.tablename}:`, {
        headersCount: headers.length,
        contentCount: content.length
      });

      state.commit("modifyMultiple", [
        {
          property: "tableHeaders",
          value: headers
        },
        {
          property: "tableContent",
          value: content
        }
      ]);
    } catch (error) {
      console.error(
        `getData: Error fetching data for ${payload.tablename}:`,
        error
      );
      state.commit("modifyMultiple", [
        {
          property: "tableHeaders",
          value: []
        },
        {
          property: "tableContent",
          value: []
        }
      ]);
    }
  },

  async getDataForDispute(state, payload) {
    let response = (await getDataForDispute(payload)) as any;

    state.commit("modify", {
      property: "HygienistForDispute",
      value: response.hygienists
    });
    state.commit("modify", {
      property: "LocationForDispute",
      value: response.locations
    });
    return response;
  },

  async simpleSearch(state, payload) {
    try {
      const response = (await simpleSearchApi(payload)) as any;

      // Store the search results in state
      state.commit("modify", {
        property: "HygienistForDispute",
        value: response?.hygienists || []
      });
      state.commit("modify", {
        property: "LocationForDispute",
        value: response?.locations || []
      });
      state.commit("modify", {
        property: "JobsForDispute",
        value: response?.jobs || []
      });

      return response;
    } catch (error) {
      console.error("🔍 Vuex simpleSearch error:", error);
      throw error;
    }
  },

  async getCommentsForDispute(state, payload) {
    try {
      let response = (await getCommentsForDispute(payload)) as any;
      state.commit("modify", {
        property: "HygienistComments",
        value: response.hygienistComments
      });
      state.commit("modify", {
        property: "LocationComments",
        value: response.locationComments
      });
      return response;
    } catch (error) {
      state.commit("modifyMultiple", [
        {
          property: "ErrorDialogShow",
          value: true
        },
        {
          property: "ServerError",
          value: "Error"
        }
      ]);
    }
  },

  async updateDonationAmount(state, payload) {
    try {
      return (await updateDonationAmount(payload)) as any;
    } catch (err) {
      console.error("updateDonationAmount error");
    }
  },

  async getPaymentIntegrities(state, payload) {
    try {
      let response = (await getPaymentIntegrities(payload)) as any;
      state.commit("modify", {
        property: "PaymentIntegrities",
        value: response
      });
      return response;
    } catch (err) {
      console.error(err);
    }
  },

  async getUnresolvedPayments(state, payload) {
    try {
      let response = await getUnresolvedPayments();
      state.commit("modify", {
        property: "PaymentIntegrities",
        value: response
      });
      return response;
    } catch (err) {
      console.error(err);
    }
  },

  async addAdminLogging(state, payload) {
    try {
      return await addAdminLogging(payload);
    } catch (err) {
      console.error("addAdminLogging error");
    }
  },

  async getPaginateData(state, payload) {
    let response = await getPaginateItems(payload);

    // Guard against a missing/invalid response. If the API returned anything
    // other than an array (e.g. transient error payload), treat it as empty so
    // we still clear stale rows instead of leaving the grid in an inconsistent
    // state versus `totalItems`.
    if (!Array.isArray(response)) {
      response = [];
    }

    if (response.length && state.state.sortBy.length) {
      const sortBy = state.state.sortBy;
      const sortDesc = state.state.sortDesc;

      response = response.sort((a, b) => {
        const sortA = a[sortBy];
        const sortB = b[sortBy];

        if (sortDesc) {
          if (sortA < sortB) return 1;
          if (sortA > sortB) return -1;
          return 0;
        } else {
          if (sortA < sortB) return -1;
          if (sortA > sortB) return 1;
          return 0;
        }
      });
    }

    // Always commit, even when the response is empty, so a no-match search
    // clears the previously loaded rows and the grid stays in sync with
    // `totalItems` (T2-5696).
    state.commit("modifyMultiple", [
      {
        property: "tableHeaders",
        value: response.length ? getHeaders(response) : []
      },
      {
        property: "tableContent",
        value: response
      }
    ]);
  }
};
